var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.sidebarTipOpen,
              expression: "sidebarTipOpen",
            },
          ],
          staticClass: "v-tooltip__content sidebar-tip",
          style: _vm.sidebarTipStyle,
        },
        [_vm._v("\n        " + _vm._s(_vm.sidebarTipText) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "v-navigation-drawer",
        {
          attrs: { app: "", clipped: "", temporary: "" },
          nativeOn: {
            mouseover: function ($event) {
              return _vm.onSidebarHover.apply(null, arguments)
            },
            mouseleave: function ($event) {
              return _vm.hideSidebarTooltip.apply(null, arguments)
            },
          },
          model: {
            value: _vm.drawer,
            callback: function ($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer",
          },
        },
        [
          _c(
            "router-link",
            {
              staticClass: "white--text",
              staticStyle: { "text-decoration": "none" },
              attrs: { to: "/" },
            },
            [
              _c("v-img", {
                staticClass: "mx-10 mt-5 env-logo",
                attrs: { src: "../images/rcms_logo.svg" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list",
            { attrs: { nav: "", dense: "", expand: "" } },
            [
              _c(
                "v-list-item-group",
                { attrs: { "active-class": "primary--text" } },
                [
                  _vm.$gate.can("View Dashboard Analytics") ||
                  _vm.$gate.can("Report 60") ||
                  _vm.$gate.can("Summary Collection") ||
                  _vm.$gate.can("Summary of Collection Per Account") ||
                  _vm.$gate.can("Summary of Main Accounts") ||
                  _vm.$gate.can("GF-RCD/TRUST/SEF") ||
                  _vm.$gate.can("RCD") ||
                  _vm.$gate.can("Real Property Tax Collection") ||
                  _vm.$gate.can("Advance Real Property Tax Collection") ||
                  _vm.$gate.can("Barangay Shares") ||
                  _vm.$gate.can("Advance Barangay Shares") ||
                  _vm.$gate.can("Report on RPT (Basic / SEF)") ||
                  _vm.$gate.can("RGR") ||
                  _vm.$gate.can("RAAF") ||
                  _vm.$gate.can("RAAF (Amount and Cancelled OR)") ||
                  _vm.$gate.can("CRAAF") ||
                  _vm.$gate.can("OR Acceptance") ||
                  _vm.$gate.can("Abstract") ||
                  _vm.$gate.can("Inquiry") ||
                  _vm.$gate.can("View Report History List") ||
                  _vm.$gate.can("View RCD List") ||
                  _vm.$gate.can("View Own RCD List") ||
                  _vm.$gate.can("View Online Payments")
                    ? _c("v-subheader", [
                        _vm._v(
                          "\n                    ANALYTICS\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("View Dashboard Analytics")
                    ? _c(
                        "v-list-item",
                        { attrs: { to: "/" } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v(
                                  "\n                            mdi-tablet-dashboard\n                        "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("Dashboard")])],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("Report 60") ||
                  _vm.$gate.can("Summary Collection") ||
                  _vm.$gate.can("Summary of Collection Per Account") ||
                  _vm.$gate.can("Summary of Main Accounts") ||
                  _vm.$gate.can("GF-RCD/TRUST/SEF") ||
                  _vm.$gate.can("RCD") ||
                  _vm.$gate.can("Real Property Tax Collection") ||
                  _vm.$gate.can("Advance Real Property Tax Collection") ||
                  _vm.$gate.can("Barangay Shares") ||
                  _vm.$gate.can("Advance Barangay Shares") ||
                  _vm.$gate.can("Report on RPT (Basic / SEF)") ||
                  _vm.$gate.can("View Report History List") ||
                  _vm.$gate.can("View RCD List") ||
                  _vm.$gate.can("View Own RCD List") ||
                  _vm.$gate.can("RGR") ||
                  _vm.$gate.can("RAAF") ||
                  _vm.$gate.can("RAAF (Amount and Cancelled OR)") ||
                  _vm.$gate.can("CRAAF") ||
                  _vm.$gate.can("OR Acceptance") ||
                  _vm.$gate.can("Abstract") ||
                  _vm.$gate.can("View Online Payments") ||
                  _vm.$gate.can("CSM Report")
                    ? _c(
                        "v-list-group",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item-icon",
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "primary" } },
                                          [
                                            _vm._v(
                                              "\n                                mdi-file-document-multiple-outline\n                            "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("Reports"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3202047419
                          ),
                        },
                        [
                          _vm._v(" "),
                          _vm.$gate.can("Report 60") ||
                          _vm.$gate.can("Summary Collection") ||
                          _vm.$gate.can("Summary of Collection Per Account") ||
                          _vm.$gate.can("Summary of Main Accounts") ||
                          _vm.$gate.can("GF-RCD/TRUST/SEF") ||
                          _vm.$gate.can("RCD") ||
                          _vm.$gate.can("RGR") ||
                          _vm.$gate.can("RAAF") ||
                          _vm.$gate.can("RAAF (Amount and Cancelled OR)") ||
                          _vm.$gate.can("CRAAF") ||
                          _vm.$gate.can("OR Acceptance") ||
                          _vm.$gate.can("Abstract")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/gen-summ" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [
                                          _vm._v(
                                            "\n                                mdi-all-inclusive\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                                Collections\n                            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("Real Property Tax Collection") ||
                          _vm.$gate.can(
                            "Advance Real Property Tax Collection"
                          ) ||
                          _vm.$gate.can("Barangay Shares") ||
                          _vm.$gate.can("Advance Barangay Shares") ||
                          _vm.$gate.can("Report on RPT (Basic / SEF)")
                            ? _c(
                                "v-list-item",
                                { staticClass: "pl-7", attrs: { to: "/rpt" } },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-map-legend")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [_c("v-list-item-title", [_vm._v("RPT")])],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View RCD List") ||
                          _vm.$gate.can("View Own RCD List")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/report-rcd" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-book-account-outline")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("RCD List"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View Report History List")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/report-history" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-history")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("History"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View Online Payments")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/online-payments" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [
                                          _vm._v(
                                            "\n                                mdi-cash-multiple\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Online Payments"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("CSM Report")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/csm-scope" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-clipboard-check-outline")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("CSM Report"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("Inquiry") ||
                  _vm.$gate.can("Cashier Collections")
                    ? _c(
                        "v-list-item",
                        { attrs: { to: "/inquiry" } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v(
                                  "\n                            mdi-clipboard-list-outline\n                        "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("Inquiry")])],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("RPT Data Sync") ||
                  _vm.$gate.can("View Transaction List") ||
                  _vm.$gate.can("Create Transaction") ||
                  _vm.$gate.can("CTC Individual") ||
                  _vm.$gate.can("CTC Corporation") ||
                  _vm.$gate.can("Encoding") ||
                  _vm.$gate.can("View SHT List") ||
                  _vm.$gate.can("View CTC List") ||
                  _vm.$gate.can("View Report 60 List") ||
                  _vm.$gate.can("View Collection Names") ||
                  _vm.$gate.can("View GF-RCD/TRUST/SEF List") ||
                  _vm.$gate.can("View Main Account List") ||
                  _vm.$gate.can("View Summary of Collection List") ||
                  _vm.$gate.can("View Employee List") ||
                  _vm.$gate.can("View Cancelled OR List") ||
                  _vm.$gate.can("View OR List") ||
                  _vm.$gate.can("View Barangay List") ||
                  _vm.$gate.can("View User List") ||
                  _vm.$gate.can("View Log List") ||
                  _vm.$gate.can("View Department List") ||
                  _vm.$gate.can("View Holidays") ||
                  _vm.$gate.can("Check Payment") ||
                  _vm.$gate.can("View Remittance") ||
                  _vm.$gate.can("View Remittance Admin") ||
                  _vm.$gate.can("View Summary of Collections Per Account") ||
                  _vm.$gate.can("View Cancelled OR List Admin") ||
                  _vm.$gate.can("View OR Swapping") ||
                  _vm.$gate.can("View OR Swapping Admin") ||
                  _vm.$gate.can("View Held OR List") ||
                  _vm.$gate.can("View Held OR List Admin") ||
                  _vm.$gate.can("Tax Order Payment") ||
                  _vm.$gate.can("Settings")
                    ? _c("v-subheader", [
                        _vm._v(
                          "\n                    APPLICATIONS\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("Create Transaction") ||
                  _vm.$gate.can("CTC Individual") ||
                  _vm.$gate.can("CTC Corporation") ||
                  _vm.$gate.can("View SHT List") ||
                  _vm.$gate.can("View CTC List") ||
                  _vm.$gate.can("Check Payment") ||
                  _vm.$gate.can("Tax Order Payment") ||
                  _vm.$gate.can("Encoding")
                    ? _c(
                        "v-list-group",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item-icon",
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "primary" } },
                                          [
                                            _vm._v(
                                              "\n                                mdi-cash-multiple\n                            "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("Payment"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3612495852
                          ),
                        },
                        [
                          _vm._v(" "),
                          _vm.$gate.can("Tax Order Payment")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/payment-order" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-cash")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                                Tax Order Payment\n                            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("Create Transaction")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/cashier" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-cash")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                                Create Payment\n                            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("CTC Individual")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/ctc-ind" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-cash")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                                CTC Individual\n                            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("CTC Corporation")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/ctc-corp" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-cash")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                                CTC Corporation\n                            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("Check Payment")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/check" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-cash")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                                Check Payment\n                            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("Encoding")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/multi-payment" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [
                                          _vm._v(
                                            "\n                                mdi-cash-multiple\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                                Encoding\n                            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View SHT List") ||
                          _vm.$gate.can("View CTC List")
                            ? _c(
                                "v-list-group",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-list-item-icon",
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "pl-5",
                                                    attrs: { color: "primary" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    mdi-map-legend\n                                "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("RPT"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    4162279920
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _vm.$gate.can("View SHT List")
                                    ? _c(
                                        "v-list-item",
                                        {
                                          staticClass: "pl-12",
                                          attrs: { to: "/sht-list" },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                                    mdi-cash-marker\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v("SHT"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$gate.can("View CTC List")
                                    ? _c(
                                        "v-list-item",
                                        {
                                          staticClass: "pl-12",
                                          attrs: { to: "/ctc-list" },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                                    mdi-cash-marker\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v("CTC"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View BPLO List")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/bplo-list" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-storefront")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [_c("v-list-item-title", [_vm._v("BPLO")])],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("View Transaction List") ||
                  _vm.$gate.can("View Transaction List Admin") ||
                  _vm.$gate.can("View Encoded Transaction List") ||
                  _vm.$gate.can("View Encoded Transaction List Admin")
                    ? _c(
                        "v-list-group",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item-icon",
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "primary" } },
                                          [
                                            _vm._v(
                                              "\n                                mdi-bank-transfer\n                            "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(
                                            "\n                                Transactions\n                            "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            461581957
                          ),
                        },
                        [
                          _vm._v(" "),
                          _vm.$gate.can("View Transaction List") ||
                          _vm.$gate.can("View Transaction List Admin")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/trans" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [
                                          _vm._v(
                                            "\n                                mdi-clipboard-text-outline\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                                Single Transactions\n                            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View Encoded Transaction List") ||
                          _vm.$gate.can("View Encoded Transaction List Admin")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/Encoded-trans" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [
                                          _vm._v(
                                            "\n                                mdi-clipboard-text-multiple-outline\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                                Encoded Transactions\n                            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("View Transaction List") ||
                  _vm.$gate.can("View Transaction List Admin")
                    ? _c(
                        "v-list-item",
                        { attrs: { to: "/check-list" } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v("mdi-bank-check"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("Check List")])],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("View Remittance") ||
                  _vm.$gate.can("View Remittance Admin")
                    ? _c(
                        "v-list-item",
                        { attrs: { to: "/remittance" } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v("mdi-calendar-range"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("Remittance")])],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("View OR Swapping") ||
                  _vm.$gate.can("View OR Swapping Admin")
                    ? _c(
                        "v-list-item",
                        { attrs: { to: "/or-swapping" } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v("mdi-swap-horizontal"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("OR Swapping")])],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("View Cancelled OR List") ||
                  _vm.$gate.can("View Cancelled OR List Admin")
                    ? _c(
                        "v-list-item",
                        { attrs: { to: "/cancelled-or" } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v(
                                  "\n                            mdi-file-document-remove-outline\n                        "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("Cancelled OR")])],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("Request Payment Adjustment") ||
                  _vm.$gate.can("Approve Payment Adjustment")
                    ? _c(
                        "v-list-item",
                        { attrs: { to: "/payment-adjustments" } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v(
                                  "\n                            mdi-cash-sync\n                        "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v("Online Payment Adjustments"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("Manage Failed Jobs")
                    ? _c(
                        "v-list-item",
                        { attrs: { to: "/failed-jobs" } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v(
                                  "\n                            mdi-alert-octagon-outline\n                        "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v("Undelivered Payment Notifications"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("View Held OR List") ||
                  _vm.$gate.can("View Held OR List Admin")
                    ? _c(
                        "v-list-item",
                        { attrs: { to: "/held-or" } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v(
                                  "\n                            mdi-pause-circle-outline\n                        "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("Held OR")])],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("View OR List") ||
                  _vm.$gate.can("View Report 60 List") ||
                  _vm.$gate.can("View Collection Names") ||
                  _vm.$gate.can("View GF-RCD/TRUST/SEF List") ||
                  _vm.$gate.can("View Main Account List") ||
                  _vm.$gate.can("View Summary of Collection List") ||
                  _vm.$gate.can("View Department List") ||
                  _vm.$gate.can("View Barangay List") ||
                  _vm.$gate.can("View Employee List") ||
                  _vm.$gate.can("View User List") ||
                  _vm.$gate.can("View Role List") ||
                  _vm.$gate.can("View Holidays") ||
                  _vm.$gate.can("View Summary of Collections Per Account") ||
                  _vm.$gate.can("View CSM Service List") ||
                  _vm.$gate.can("Settings")
                    ? _c(
                        "v-list-group",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item-icon",
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "primary" } },
                                          [_vm._v("mdi-apps")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(
                                            "\n                                Management\n                            "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3011511283
                          ),
                        },
                        [
                          _vm._v(" "),
                          _vm.$gate.can("View Report 60 List") ||
                          _vm.$gate.can("View Collection Names") ||
                          _vm.$gate.can("View GF-RCD/TRUST/SEF List") ||
                          _vm.$gate.can("View Main Account List") ||
                          _vm.$gate.can("View Summary of Collection List") ||
                          _vm.$gate.can(
                            "View Summary of Collections Per Account"
                          ) ||
                          _vm.$gate.can("View CSM Service List")
                            ? _c(
                                "v-list-group",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-list-item-icon",
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "pl-5",
                                                    attrs: { color: "primary" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    mdi-format-list-text\n                                "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    "\n                                    Collections\n                                "
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    69685391
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _vm.$gate.can("View Collection Names")
                                    ? _c(
                                        "v-list-item",
                                        {
                                          staticClass: "pl-12",
                                          attrs: { to: "/coll-accts" },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                                    mdi-format-list-bulleted-square\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  "\n                                    Collection Accounts\n                                "
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$gate.can("View Report 60 List")
                                    ? _c(
                                        "v-list-item",
                                        {
                                          staticClass: "pl-12",
                                          attrs: { to: "/nature-of-tax" },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                                    mdi-format-list-group\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  "\n                                    Report 60\n                                "
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$gate.can(
                                    "View Summary of Collections Per Account"
                                  )
                                    ? _c(
                                        "v-list-item",
                                        {
                                          staticClass: "pl-12",
                                          attrs: {
                                            to: "/summ-of-coll-per-acct",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                                    mdi-format-list-group\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  "\n                                    Summary of Collections Per\n                                    Account\n                                "
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$gate.can(
                                    "View Summary of Collection List"
                                  )
                                    ? _c(
                                        "v-list-item",
                                        {
                                          staticClass: "pl-12",
                                          attrs: { to: "/summ-of-coll" },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                                    mdi-format-list-group\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  "\n                                    Summary of Collections/Revenue\n                                    Generated Report\n                                "
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$gate.can("View Main Account List")
                                    ? _c(
                                        "v-list-item",
                                        {
                                          staticClass: "pl-12",
                                          attrs: { to: "/main-accounts" },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                                    mdi-format-list-group\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  "\n                                    Summary of Main Accounts\n                                "
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$gate.can("View GF-RCD/TRUST/SEF List")
                                    ? _c(
                                        "v-list-item",
                                        {
                                          staticClass: "pl-12",
                                          attrs: { to: "/gf-rcd-trust-sef" },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                                    mdi-format-list-group\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  "\n                                    GF/SEF/TRUST\n                                "
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$gate.can("View CSM Service List")
                                    ? _c(
                                        "v-list-item",
                                        {
                                          staticClass: "pl-12",
                                          attrs: { to: "/csm-services" },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "mdi-clipboard-list-outline"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v("CSM Services"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View OR List")
                            ? _c(
                                "v-list-item",
                                { staticClass: "pl-7", attrs: { to: "/or" } },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [
                                          _vm._v(
                                            "\n                                mdi-script-text-outline\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                                Official Receipts\n                            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View Department List")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/department-list" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-lan")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                                Department/Transaction Type\n                            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View Barangay List")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/brgys" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-map-legend")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Barangays"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View Employee List")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/employees" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [
                                          _vm._v(
                                            "\n                                mdi-account-group\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Employees"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View User List")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/user-mgt" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [
                                          _vm._v(
                                            "\n                                mdi-account-group-outline\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Users"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View Role List")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/roles-permissions" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [
                                          _vm._v(
                                            "\n                                mdi-shield-account-outline\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                                Roles and Permissions\n                            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View Holidays")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/holidays" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [
                                          _vm._v(
                                            "\n                                mdi-calendar-multiselect\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Holidays"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("View Announcements")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/announcements" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [
                                          _vm._v(
                                            "\n                                mdi-bullhorn-outline\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Announcements"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$gate.can("Settings")
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pl-7",
                                  attrs: { to: "/settings" },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-cog")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Settings"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$gate.can("View Log List")
                    ? _c(
                        "v-list-item",
                        { attrs: { to: "/logs" } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v(
                                  "\n                            mdi-file-document-edit-outline\n                        "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("Logs")])],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-app-bar",
        { attrs: { color: "primary", app: "", clipped: "", dark: "" } },
        [
          _vm.$gate.can("View Dashboard Analytics") ||
          _vm.$gate.can("Report 60") ||
          _vm.$gate.can("Summary Collection") ||
          _vm.$gate.can("Summary of Collection Per Account") ||
          _vm.$gate.can("Summary of Main Accounts") ||
          _vm.$gate.can("GF-RCD/TRUST/SEF") ||
          _vm.$gate.can("RCD") ||
          _vm.$gate.can("RGR") ||
          _vm.$gate.can("RAAF") ||
          _vm.$gate.can("RAAF (Amount and Cancelled OR)") ||
          _vm.$gate.can("CRAAF") ||
          _vm.$gate.can("OR Acceptance") ||
          _vm.$gate.can("Real Property Tax Collection") ||
          _vm.$gate.can("Advance Real Property Tax Collection") ||
          _vm.$gate.can("Barangay Shares") ||
          _vm.$gate.can("Advance Barangay Shares") ||
          _vm.$gate.can("Report on RPT (Basic / SEF)") ||
          _vm.$gate.can("RPT Data Sync") ||
          _vm.$gate.can("View Transaction List") ||
          _vm.$gate.can("Create Transaction") ||
          _vm.$gate.can("Encoding") ||
          _vm.$gate.can("View SHT List") ||
          _vm.$gate.can("View CTC List") ||
          _vm.$gate.can("View Report 60 List") ||
          _vm.$gate.can("View Collection Names") ||
          _vm.$gate.can("View GF-RCD/TRUST/SEF List") ||
          _vm.$gate.can("View Main Account List") ||
          _vm.$gate.can("View Summary of Collection List") ||
          _vm.$gate.can("View Employee List") ||
          _vm.$gate.can("View Cancelled OR List") ||
          _vm.$gate.can("View OR List") ||
          _vm.$gate.can("View Barangay List") ||
          _vm.$gate.can("View User List") ||
          _vm.$gate.can("View Log List") ||
          _vm.$gate.can("View Department List") ||
          _vm.$gate.can("View Holidays") ||
          _vm.$gate.can("View Report History List") ||
          _vm.$gate.can("Check Payment") ||
          _vm.$gate.can("View Summary of Collections Per Account") ||
          _vm.$gate.can("RGR") ||
          _vm.$gate.can("View Encoded Transaction List") ||
          _vm.$gate.can("View Encoded Transaction List Admin") ||
          _vm.$gate.can("View Transaction List Admin") ||
          _vm.$gate.can("CTC Individual") ||
          _vm.$gate.can("CTC Corporation") ||
          _vm.$gate.can("View BPLO List") ||
          _vm.$gate.can("View Remittance") ||
          _vm.$gate.can("View Remittance Admin") ||
          _vm.$gate.can("View Cancelled OR List Admin") ||
          _vm.$gate.can("Abstract") ||
          _vm.$gate.can("View OR Swapping") ||
          _vm.$gate.can("View OR Swapping Admin") ||
          _vm.$gate.can("View Held OR List") ||
          _vm.$gate.can("View Held OR List Admin") ||
          _vm.$gate.can("Tax Order Payment") ||
          _vm.$gate.can("Settings")
            ? _c("v-app-bar-nav-icon", {
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.drawer = !_vm.drawer
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("v-toolbar-title", [
            _vm._v(
              "\n            Revenue Collection Management System (RCMS)\n        "
            ),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on, attrs }) {
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "mr-1",
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  _vm.darkMode = !_vm.darkMode
                                },
                              },
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c("v-icon", [
                            _vm._v(
                              _vm._s(
                                _vm.darkMode
                                  ? "mdi-weather-night"
                                  : "mdi-white-balance-sunny"
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.darkMode
                      ? "Switch to Light Mode"
                      : "Switch to Night Mode"
                  )
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.$gate.can("Notifications") ? _c("notif") : _vm._e(),
          _vm._v(" "),
          _c(
            "v-menu",
            {
              attrs: {
                "offset-y": "",
                "close-on-content-click": _vm.closeOnClick,
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on, attrs }) {
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            { staticClass: "mr-1", attrs: { icon: "" } },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c(
                            "v-avatar",
                            { attrs: { color: "white", size: "40" } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "primary--text text-h5 text-capitalize",
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.name[0]) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "v-card",
                { staticClass: "text-center p-2" },
                [
                  _c(
                    "v-avatar",
                    {
                      staticClass: "mt-3",
                      attrs: { color: "primary", size: "78" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "white--text text-h3 text-capitalize" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.name[0]) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "text-h6 text-capitalize" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.name) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "text-capitalize" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.role) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mb-3",
                                  attrs: { color: "primary", small: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.route("/profile"),
                                        (_vm.closeOnClick = true)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Manage Account\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "secondary",
                                    dark: "",
                                    small: "",
                                    loading: _vm.loading,
                                  },
                                  on: { click: _vm.logout },
                                },
                                [
                                  _vm._v(
                                    "\n                                Logout\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-main",
        [
          _c("announcement-banner"),
          _vm._v(" "),
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c("router-view"),
              _vm._v(" "),
              _c("snackbar", { ref: "sysAlert", attrs: { global: true } }),
              _vm._v(" "),
              _c("notifyAlert", { ref: "sysnotifyAlert" }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }